import { select, takeEvery } from 'redux-saga/effects';

import * as authSelectors from '@redux/reducers/auth';
import { store } from '@redux/storeConfig/store';
import camelcaseKeys from 'camelcase-keys';
import { normalize } from 'normalizr';
import * as actions from '../actions';
import * as schemas from '../schemas';
import { getDestinationListService } from '../services';
import * as types from '../types';

/* -------------------------------------------------------------------------- */
/*                                 FETCH LIST                                 */
/* -------------------------------------------------------------------------- */
function* fetchETAMonitoringDestinationList(action) {
  const {
    operatorId: filterOperatorId,
    organizationId: filterOrganizationId,
    userId: filterUserId
  } = action.payload;
  const { operatorId, organizationId } = yield select(authSelectors.getAuthUserMembershipFilters, {
    filterOperatorId,
    filterOrganizationId
  });

  getDestinationListService(
    { operatorId, organizationId },
    {
      successAction: (response) => {
        const resultData = response.data.map((result) => camelcaseKeys(result));
        console.log('resultData getDestinationListService', resultData);
        const {
          entities: { destinations },
          result //order
        } = normalize(resultData, schemas.Destinations); //normalize data to byId and order
        store.dispatch(
          actions.completeFetchingDestination(destinations, result, operatorId, organizationId)
        );
      },
      errorAction: (error) => {
        store.dispatch(actions.failFetchingDestination(error));
      }
    }
  );
}

export function* watchFetchETAModelList() {
  yield takeEvery(
    types.ETAMONITORING_DESTINATIONS_FETCH_STARTED,
    fetchETAMonitoringDestinationList
  );
}
